module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_7005.4178ca9b.png";